module.exports = __webpack_public_path__ + "img/fridge.be5030ca.webp";